import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconVimeo24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconVimeo24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M20.992 8.472q-.119 2.53-3.668 6.932Q13.644 20 11.105 20q-1.572 0-2.66-2.8l-1.453-5.13q-.81-2.799-1.734-2.8-.202 0-1.41.817L3 9.037q1.334-1.126 2.625-2.25 1.78-1.479 2.666-1.557 2.1-.195 2.586 2.768.524 3.195.72 3.98.608 2.65 1.333 2.65.566 0 1.697-1.72 1.13-1.72 1.21-2.619.162-1.483-1.21-1.484c-.46.006-.913.103-1.332.283q1.333-4.2 5.074-4.085 2.775.08 2.623 3.47"
            />
        </svg>
    );
}
export default memo(IconVimeo24);
